import { useEffect, useRef } from 'react'

export const useTokenExpiration = (token: string | null, onLogout: () => void, showModal: () => void) => {
  const warningRef = useRef<number | null>(null)
  const timeoutRef = useRef<number | null>(null)

  useEffect(() => {
    if (!token) return

    try {
      const payload = JSON.parse(atob(token.split('.')[1]))
      const expTime = payload.exp * 1000
      const now = Date.now()

      const timeUntilWarning = expTime - now - 60_000
      const timeUntilLogout = expTime - now

      if (timeUntilWarning > 0) {
        warningRef.current = window.setTimeout(() => {
          showModal()
        }, timeUntilWarning)
      }

      timeoutRef.current = window.setTimeout(() => {
        onLogout()
      }, timeUntilLogout)
    } catch (err) {
      console.error('Invalid JWT token:', err)
      onLogout()
    }

    return () => {
      if (warningRef.current) {
        clearTimeout(warningRef.current)
      }

      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [token])
}
